import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import React from 'react';
import styles from './sidebar.module.scss';
import classNames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
export var Sidebar = function Sidebar(_ref) {
  var _ref$isSideBarOpen = _ref.isSideBarOpen,
      isSideBarOpen = _ref$isSideBarOpen === void 0 ? false : _ref$isSideBarOpen,
      children = _ref.children,
      className = _ref.className;
  return /*#__PURE__*/_jsx("div", {
    className: classNames(styles.sidebar, 'd-flex flex-column shadow-100', className, _defineProperty({}, styles.open, isSideBarOpen)),
    children: children
  });
};
export default Sidebar;